module.exports = __webpack_public_path__ + "img/share.afb595e7.png";